import { prompt, type PromptDefinition } from './models';

export const OTHER_PROMPTS = [
    prompt(
        'Understand it',
        'What information is available about this building?',
        'Which buildings have the most complete information available?'
    ),
    prompt(
        'Find evidence',
        "Which recent reports explain this building's current condition?",
        'Which buildings have recent condition reports available to review?'
    ),
    prompt(
        'Coordinate people',
        'Who are the recorded contacts for this building?',
        'Which buildings have missing or outdated contact records?'
    ),
    prompt(
        'Find evidence',
        'Find general building information for this building about…',
        'Find general building information across my buildings about…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        'What safety information is available for visitors to this building?',
        'Which buildings have visitor safety information available?'
    ),
    prompt(
        'Keep it running',
        'What work has recently been recorded for this building?',
        'Compare recently recorded work across my buildings.'
    ),
    prompt(
        'Understand it',
        "Which issues are listed as open in this building's records?",
        'Which buildings have open issues in their available records?'
    ),
    prompt(
        'Find evidence',
        'Find recent building reports for this building concerning…',
        'Find recent building reports across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Find evidence',
        "Which parts of this building's records are missing or outdated?",
        'Which buildings have the largest general information gaps?'
    ),
    prompt(
        'Understand it',
        'What do the records say about how this building is used?',
        'Compare documented building uses across my portfolio.'
    ),
    prompt(
        'Understand it',
        'Summarise the key facts about this building and cite the records.',
        'Summarise key facts and information gaps across my buildings.'
    ),
    prompt(
        'Find evidence',
        "Help me explore this building's records for information about…",
        'Help me explore records across my buildings for information about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
